import { MailCheck, FileText, Cpu } from 'lucide-react';


// Conversion du statut en status pour les classes CSS
export const mapStatusToClass = (status) => {
  if (status === "Opérationnel") return "operational";
  if (status === "Dégradé") return "degraded";
  if (status === "Hors ligne") return "down";
  return "down";
};


// Gestion du status et des messages pour les services externes
export const getServiceStatus = (data_service) => {
  if (!data_service || !data_service.data || data_service.data.length === 0) {
    return "unknown";
  }
  
  for (const service of data_service.data) {
    if (service.service_status === "Hors ligne") {
      return "down";
    }
  }
  
  for (const service of data_service.data) {
    if (service.service_status === "Dégradé") {
      return "degraded";
    }
  }
  
  return "operational";
};


export const getServiceStatusMessage = (serviceStatus) => {
  const serviceStatusMessage = {
    operational: "Tous les services sont opérationnels",
    degraded: "Un ou plusieurs services dégradés",
    down: "Un ou plusieurs services hors ligne",
    unknown: "État des services inconnu"
  };
  return serviceStatusMessage[serviceStatus];
};



// Fonction pour l'état des serveurs de réplication (uniquement les serveurs esclaves)
export const getReplicationStatus = (data_serveur_diese) => {
  if (!data_serveur_diese || !data_serveur_diese.data || data_serveur_diese.data.length === 0) {
    return "unknown";
  }
  
  // On ne considère que les serveurs de type esclave
  const replicationServers = data_serveur_diese.data.filter(server => 
    server.server_type !== "Maître"
  );
  
  if (replicationServers.length === 0) {
    return "unknown";
  }
  
  for (const server of replicationServers) {
    if (server.server_status === "Hors ligne") {
      return "down";
    }
  }
  
  for (const server of replicationServers) {
    if (server.server_status === "Dégradé") {
      return "degraded";
    }
  }
  
  return "operational";
};



export const getReplicationStatusMessage = (replicationStatus) => {
  const replicationStatusMessage = {
    operational: "Tous opérationnels",
    degraded: "Un ou plusieurs serveurs dégradés",
    down: "Un ou plusieurs serveurs hors ligne",
    unknown: "État inconnu"
  };
  return replicationStatusMessage[replicationStatus];
};



// Fonction pour l'état général de tous les serveurs
export const getOverallStatus = (data_serveur_diese) => {
  if (!data_serveur_diese || !data_serveur_diese.data || data_serveur_diese.data.length === 0) {
    return "unknown";
  }
  
  for (const server of data_serveur_diese.data) {
    if (server.server_status === "Hors ligne") {
      return "down";
    }
  }
  
  for (const server of data_serveur_diese.data) {
    if (server.server_status === "Dégradé") {
      return "degraded";
    }
  }
  
  return "operational";
};



export const getOverallStatusMessage = (overallStatus) => {
  const overallStatusMessage = {
    operational: "Système opérationnel",
    degraded: "Système dégradé",
    down: "Système hors ligne",
    unknown: "État du système inconnu"
  };
  return overallStatusMessage[overallStatus];
};



// Fonction pour obtenir l'icône appropriée pour un service
export const getServiceIcon = (serviceName) => {
  if (serviceName.toLowerCase().includes('mail') || serviceName.toLowerCase().includes('mandrill')) {
    return <MailCheck className="icon" />;
  } else if (serviceName.toLowerCase().includes('pdf') || serviceName.toLowerCase().includes('générateur')) {
    return <FileText className="icon" />;
  } else {
    return <Cpu className="icon" />;
  }
};



// Formatage de la date
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('fr-FR');
};



// Calculer les statistiques des serveurs
export const getServerStats = (data_serveur_diese) => {
  if (!data_serveur_diese || !data_serveur_diese.data) return { total: 0, operational: 0, degraded: 0, down: 0 };
  
  const total = data_serveur_diese.data.length;
  const degraded = data_serveur_diese.data.filter(s => s.server_status === "Dégradé").length;
  const down = data_serveur_diese.data.filter(s => s.server_status === "Hors ligne").length;
  const operational = total - degraded - down;
  
  return { total, operational, degraded, down };
};



export const isPercentValue = (raw) => {
  if (!raw) return false;
  return /^[\d.]+\s*%/.test(raw) || /^[\d.]+\s*[A-Za-z]*\s*\(\d+%\)/.test(raw);
};

export const parseMetricValue = (rawValue) => {
  if (!rawValue) {
    return { percent: null, display: 'N/A' };
  }

  const percentMatch = rawValue.match(/^(\d+(?:\.\d+)?)\s*%/);
  if (percentMatch) {
    return { percent: Math.min(parseFloat(percentMatch[1]), 100), display: rawValue };
  }

  const ratioMatch = rawValue.match(/^([\d.]+)\s*(GB|MB|KB)\s*\/\s*([\d.]+)\s*(GB|MB|KB)/i);
  if (ratioMatch) {
    const used  = parseFloat(ratioMatch[1]);
    const total = parseFloat(ratioMatch[3]);
    return { percent: Math.min((used / total) * 100, 100), display: rawValue };
  }

  return { percent: null, display: rawValue };
};

// Calculer les statistiques des services
export const getServiceStats = (data_service) => {
  if (!data_service || !data_service.data) return { total: 0, operational: 0, degraded: 0, down: 0 };
  
  const total = data_service.data.length;
  const operational = data_service.data.filter(s => s.service_status === "Opérationnel").length;
  const degraded = data_service.data.filter(s => s.service_status === "Dégradé").length;
  const down = total - operational - degraded;
  
  return { total, operational, degraded, down };
};